import { PropsWithChildren, useMemo } from 'react';
import useStore from '../hooks/store/useStore';
import { REDUX_STORE_SLICES } from '../services/exports/Constants';
import useMobileApp from '../hooks/mobile-app/useMobileApp';
import DownloadMobileAppModal from '../modals/marketing/DownloadMobileAppModal';
import ReduxActions from '../store/ReduxActions';
import { actionCreators } from '../store/actions';
import useInitialData from '../hooks/global/useInitialData';
import useScreenType from '../hooks/utility/useScreenType';
import useAppState from '../hooks/global/useAppState';

const MarketingProvider = ({ children }: PropsWithChildren) => {
  const { isMobileApp } = useMobileApp();
  const { data, loading } = useInitialData();
  const { franchise } = data;
  const { menu } = useAppState();
  const { mobile_app } = useStore<REDUX_STORE_SLICES.MARKETING>(REDUX_STORE_SLICES.MARKETING);
  const { isDesktop } = useScreenType();

  const DownloadMobileApp = useMemo(() => {
    if (
      isMobileApp ||
      !franchise?.mobile_app_uuid ||
      !franchise.show_mobile_app_download_popup ||
      mobile_app?.download_modal_seen ||
      loading ||
      isDesktop ||
      !menu?.menuLoaded
    ) {
      return null;
    }
    return (
      <DownloadMobileAppModal
        onClose={() => {
          ReduxActions.dispatch(
            actionCreators.marketing.updateMobileApp({
              download_modal_seen: true,
            }),
          );
        }}
      />
    );
  }, [
    isMobileApp,
    franchise?.mobile_app_uuid,
    franchise?.show_mobile_app_download_popup,
    mobile_app?.download_modal_seen,
    loading,
    isDesktop,
    menu?.menuLoaded,
  ]);
  return (
    <>
      {children}
      {DownloadMobileApp}
    </>
  );
};

export default MarketingProvider;
